module.exports = __webpack_public_path__ + "img/132.529ea0f4.jpg";